import styled from "styled-components";

export const NameCol = styled.div`
  width: 250px;
  word-wrap: break-word;
`;

export const SmallerNameCol = styled.div`
  width: 175px;
  word-wrap: break-word;
`;

export const SmallerNumCol = styled.div`
  width: 60px;
  word-wrap: break-word;
`;

export const NumCol = styled.div`
  width: 125px;
  word-wrap: break-word;
`;

export const DescriptionCol = styled.div`
  width: 500px;
  word-wrap: break-word;
`;
